<template>
  <section class="grey_bg" aria-labelledby="charter-heading">
    <div class="container mt-4">
      <h1 id="charter-heading" class="display-1 page-title">
        <span class="heading_bdr_btm">Investor Charter</span>
      </h1>

      <h2 class="my-2">A. Vision and Mission Statements for investors</h2>
      <h3 class="charter-subheading">Vision</h3>
      <p>Invest with knowledge &amp; safety.</p>
      <h3 class="charter-subheading">Mission</h3>
      <p>Every investor should be able to invest in right investment products based on their needs, manage and monitor them to meet their goals, access reports and enjoy financial wellness.</p>

      <h2 class="my-2">B. Details of business transacted by the Research Analyst with respect to the investors</h2>
      <ul class="ml-4">
        <li>To publish research report based on the research activities of the RA</li>
        <li>To provide an independent unbiased view on securities.</li>
        <li>To offer unbiased recommendation, disclosing the financial interests in recommended securities.</li>
        <li>To provide research recommendation, based on analysis of publicly available information and known observations.</li>
        <li>To conduct audit annually</li>
        <li>To ensure that all advertisements are in adherence to the provisions of the Advertisement Code for Research Analysts.</li>
        <li>To maintain records of interactions, with all clients including prospective clients (prior to onboarding), where any conversation related to the research services has taken place.</li>
      </ul>

      <h2 class="my-2">C. Details of services provided to investors (No Indicative Timelines)</h2>
      <ul class="ml-4">
        <li>Onboarding of Clients:
          <ul>
            <li>Sharing of terms and conditions of research services</li>
            <li>Completing KYC of fee paying clients</li>
          </ul>
        </li>
        <li>Disclosure to Clients:
          <ul>
            <li>To disclose, information that is material for the client to make an informed decision, including details of its business activity, disciplinary history, the terms and conditions of research services, details of associates, risks and conflicts of interest, if any</li>
            <li>To disclose the extent of use of Artificial Intelligence tools in providing research services</li>
            <li>To disclose, while distributing a third party research report, any material conflict of interest of such third party research provider or provide web address that directs a recipient to the relevant disclosures</li>
            <li>To disclose any conflict of interest of the activities of providing research services with other activities of the research analyst</li>
          </ul>
        </li>
        <li>To distribute research reports and recommendations to the clients without discrimination</li>
        <li>To maintain confidentiality w.r.t publication of the research report until made available in the public domain</li>
        <li>To respect data privacy rights of clients and take measures to protect unauthorized use of their confidential information</li>
        <li>To disclose the timelines for the services provided by the research analyst to clients and ensure adherence to the said timelines</li>
        <li>To provide clear guidance and adequate caution notice to clients when providing recommendations for dealing in complex and high-risk financial products/services</li>
        <li>To treat all clients with honesty and integrity</li>
        <li>To ensure confidentiality of information shared by clients unless such information is required to be provided in furtherance of discharging legal obligations or a client has provided specific consent to share such information</li>
      </ul>

      <h2 class="my-2">D. Details of grievance redressal mechanism and how to access it</h2>
      <p>1. Investor can lodge complaint/grievance against Research Analyst in the following ways:</p>
      <ul class="ml-4">
        <li><strong>Mode of filing the complaint with research analyst:</strong> In case of any grievance / complaint, an investor may approach the concerned Research Analyst who shall strive to redress the grievance immediately, but not later than 21 days of the receipt of the grievance.</li>
        <li><strong>Mode of filing the complaint on SCORES or with Research Analyst Administration and Supervisory Body (RAASB):</strong>
          <ul>
            <li>SCORES 2.0 (a web based centralized grievance redressal system of SEBI): <a href="https://scores.sebi.gov.in" target="_blank" rel="noopener noreferrer">https://scores.sebi.gov.in</a></li>
            <li>Two level review for complaint/grievance against Research Analyst:
              <ul>
                <li>First review done by designated body (RAASB)</li>
                <li>Second review done by SEBI</li>
              </ul>
            </li>
            <li>Email to designated email ID of RAASB</li>
          </ul>
        </li>
      </ul>
      <p>2. If the Investor is not satisfied with the resolution provided by the Market Participants, then the Investor has the option to file the complaint/ grievance on SMARTODR platform for its resolution through online conciliation or arbitration.</p>
      <p>With regard to physical complaints, investors may send their complaints to:</p>
      <address>
        Office of Investor Assistance and Education,<br />
        Securities and Exchange Board of India,<br />
        SEBI Bhavan, Plot No. C4-A, ‘G’ Block,<br />
        Bandra-Kurla Complex, Bandra (E),<br />
        Mumbai - 400 051
      </address>

      <h2 class="my-2">E. Rights of investors</h2>
      <ul class="ml-4">
        <li>Right to Privacy and Confidentiality</li>
        <li>Right to Transparent Practices</li>
        <li>Right to fair and Equitable Treatment</li>
        <li>Right to Adequate Information</li>
        <li>Right to Initial and Continuing Disclosure</li>
        <li>Right to receive information about all the statutory and regulatory disclosures</li>
        <li>Right to Fair &amp; True Advertisement</li>
        <li>Right to Awareness about Service Parameters and Turnaround Times</li>
        <li>Right to be informed of the timelines for each service</li>
        <li>Right to be Heard and Satisfactory Grievance Redressal</li>
        <li>Right to have timely redressal</li>
        <li>Right to Exit from Financial product or service in accordance with the terms and conditions agreed with the research analyst</li>
        <li>Right to receive clear guidance and caution notice when dealing in Complex and High-Risk Financial Products and Services</li>
        <li>Additional Rights to vulnerable consumers - Right to get access to services in a suitable manner even if differently abled</li>
        <li>Right to provide feedback on the financial products and services used</li>
        <li>Right against coercive, unfair, and one-sided clauses in financial agreements</li>
      </ul>

      <h2 class="my-2">F. Expectations from the investors (Responsibilities of investors)</h2>
      <h3 class="charter-subheading">Do’s</h3>
      <ul class="ml-4">
        <li>Always deal with SEBI registered Research Analyst.</li>
        <li>Ensure that the Research Analyst has a valid registration certificate.</li>
        <li>Check for SEBI registration number. Refer to the list of all SEBI registered Research Analyst: <a href="https://www.sebi.gov.in/sebiweb/other/OtherAction.do?doRecognisedFpi=yes&intmId=14" target="_blank" rel="noopener noreferrer">SEBI Website</a></li>
        <li>Always pay attention towards disclosures made in the research reports before investing.</li>
        <li>Pay your Research Analyst through banking channels only and maintain duly signed receipts mentioning the details of your payments. You may make payment of fees through CeFCoM of RAASB if opted by the Research Analyst. (Applicable for fee paying clients only)</li>
        <li>Before buying/ selling securities or applying in public offer, check for the research recommendation provided by your Research Analyst.</li>
        <li>Ask all relevant questions and clear your doubts with your Research Analyst before acting on recommendation.</li>
        <li>Seek clarifications and guidance on research recommendations from your Research Analyst, especially if it involves complex and high risk financial products and services.</li>
        <li>Always be aware that you have the right to stop availing the service of a Research Analyst as per the terms of service agreed between you and your Research Analyst.</li>
        <li>Always be aware that you have the right to provide feedback to your Research Analyst in respect of the services received.</li>
        <li>Always be aware that you will not be bound by any clause, prescribed by the research analyst, which is contravening any regulatory provisions.</li>
        <li>Inform SEBI about Research Analyst offering assured or guaranteed returns.</li>
      </ul>
      <h3 class="charter-subheading">Don’ts</h3>
      <ul class="ml-4">
        <li>Do not provide funds for investment to the Research Analyst.</li>
        <li>Don’t fall prey to luring advertisements or market rumors.</li>
        <li>Do not get attracted to limited period discount or other incentive, gifts, etc. offered by Research Analyst.</li>
        <li>Do not share login credential and password of your trading, demat or bank accounts with the Research Analyst.</li>
      </ul>

    </div>
  </section>
</template>

<script>
  export default {
    name: "InvestorCharter",
    mounted() {
      document.title = "Investor Charter | Grow With Stocks";
    }
  };
</script>

<style lang="scss" scoped>
  .btn_custom {
    background-color: #1a7055 !important;
    color: #fff !important;
    font-weight: 600;
    margin: auto;
    height: 50px;
    width: auto;
  }
  .fullPage {
    min-height: 100vh;
  }
  td {
    padding: 13px;
  }
  #contactus_social {
    padding: 0;
  }
  .page-title {
    text-align: left;
    margin-bottom: 30px;
    color: #1a1a1a;
    font-weight: 700;
  }
  .grey_bg {
    background: #f7f7f7;
    padding-bottom: 40px;
  }
  h2 {
    font-size: 22px;
    font-weight: 700;
    color: #1a1a1a;
    margin-top: 24px;
    text-align: left;
  }
  /* WCAG 1.3.1 — sub-section <h3> styled to match the original bold-label
     visual treatment (Vision / Mission / Do's / Don'ts). */
  .charter-subheading {
    font-size: 17px;
    font-weight: 700;
    color: #1a1a1a;
    margin-top: 18px;
    margin-bottom: 6px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/InvestorCharter.vue